import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../App.css";

function ActiveTournaments() {
  const { tournamentId } = useParams();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  // fetch entries from backend
  const fetchEntries = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/tournament/${tournamentId}/entries`
      );
      setEntries(res.data);
    } catch (err) {
      console.error("Error fetching entries:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, [tournamentId]);

  const handleScoreChange = async (entryId, newScore) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}api/updateTournamentEntry/${entryId}/score`,
        { score: parseInt(newScore, 10) }
      );
      setEntries((prev) =>
        prev.map((e) =>
          e.entryId === entryId ? { ...e, score: parseInt(newScore, 10) } : e
        )
      );
    } catch (err) {
      console.error("Error updating score:", err);
    }
  };

  const handleAdvanceWinner = async (match) => {
    if (match.length !== 2) return;
    const [p1, p2] = match;

    const winner =
      (p1.score || 0) > (p2.score || 0)
        ? p1
        : (p2.score || 0) > (p1.score || 0)
        ? p2
        : null;

    if (!winner) {
      alert("Tie or no scores set. Please enter scores to advance.");
      return;
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}api/updateTournamentEntry/${winner.entryId}/score`,
        { score: winner.score, advanced: true }
      );
      alert(`${winner.deckName} advances!`);
      fetchEntries();
    } catch (err) {
      console.error("Error advancing winner:", err);
    }
  };

  if (loading) return <p>Loading tournament...</p>;

  // group into matches of 2
  const matches = [];
  for (let i = 0; i < entries.length; i += 2) {
    matches.push(entries.slice(i, i + 2));
  }

  return (
    <div style={{ textAlign: "center" }}>
      <h1 className="main-title">Active Tournament #{tournamentId}</h1>
      <br />
      <br />

      <div className="bracket">
        {matches.map((match, idx) => (
          <div key={idx} className="match">
            {match.map((entry) => (
              <div key={entry.entryId} className="entry">
                <p>
                  <strong>{entry.deckName || "Empty Slot"}</strong>{" "}
                  {entry.username ? `(${entry.username})` : ""}
                </p>
                <input
                  type="number"
                  value={entry.score || ""}
                  placeholder="Score"
                  style={{ width: "60px", margin: "4px" }}
                  onChange={(e) =>
                    handleScoreChange(entry.entryId, e.target.value)
                  }
                />
              </div>
            ))}
            <button
              className="btn-advance"
              onClick={() => handleAdvanceWinner(match)}
            >
              Advance Winner
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ActiveTournaments;
